module.exports = __webpack_public_path__ + "static/media/mastercard.9006777c.svg";